<template>
  <div>
    <portal target-el="#filter">
      <primary-filter
        :noSearchFilter="true" />
    </portal>
  </div>
</template>
<script>
import PrimaryFilter from '@/components/common/PrimaryFilter';

export default {
  components: { PrimaryFilter },
  created() {
    const token = localStorage.getItem('tsm-user-token');
    const baseUrl = this.$route.query.serviceUrl;
    const packingSearch = this.$route.query.packingSearch;
    const procureUrl = this.$route.query.procureServiceUrl;
    let url = `https://${baseUrl}?token=${token}`;
    if (packingSearch) {
      url = `https://${baseUrl}?token=${token}&${packingSearch}`;
    } else if(procureUrl){
      url = `https://${procureUrl}`;
    }
    window.open(url, '_self');

    
  },
};
</script>
